// extracted by mini-css-extract-plugin
export default {"emptyStateDivBox":"emptyStateDivBox__NRxXV","teslaListBody":"teslaListBody__OACUp"};